import { render, staticRenderFns } from "./AgentMessages.vue?vue&type=template&id=b20abca8&scoped=true&"
import script from "./AgentMessages.vue?vue&type=script&lang=js&"
export * from "./AgentMessages.vue?vue&type=script&lang=js&"
import style0 from "./AgentMessages.vue?vue&type=style&index=0&id=b20abca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20abca8",
  null
  
)

export default component.exports